// extracted by mini-css-extract-plugin
export default {"wrapper":"b6-z","play":"c6-z"};